module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-meet-team"
  }, [_c('div', {
    staticClass: "custom-meet-team__bg"
  }, [_c('div', {
    staticClass: "custom-meet-team__angle"
  }), _c('div', {
    staticClass: "custom-meet-team__container"
  }, [_c('div', {
    staticClass: "custom-meet-team__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-meet-team__tab clearfix"
  }, [_c('div', {
    staticClass: "custom-meet-team__tableft",
    class: {
      hovernew: _vm.activeTab == 'team1', hovernew1: _vm.activeTab != 'team1'
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'team1'
      }
    }
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.marion__westerville_staff)
    }
  })]), _c('div', {
    staticClass: "custom-meet-team__tabright",
    class: {
      hovernew: _vm.activeTab == 'team2', hovernew1: _vm.activeTab != 'team2'
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'team2'
      }
    }
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.springfield_staff)
    }
  })])]), _c('div', {
    staticClass: "custom-meet-team__team clearfix",
    class: {
      show: _vm.activeTab == 'team1', hide: _vm.activeTab != 'team1'
    }
  }, _vm._l((_vm.props.cards), function(card, i) {
    return _c('div', {
      staticClass: "custom-meet-team__card",
      class: {
        'custom-meet-team__card--active': _vm.a === i || _vm.b === i || _vm.c === i
      }
    }, [_c('div', {
      staticClass: "custom-meet-team__white",
      class: {
        'custom-meet-team__white--active': _vm.a === i || _vm.b === i || _vm.c === i
      }
    }, [_c('div', {
      staticClass: "custom-meet-team__image",
      class: {
        'custom-meet-team__image--active': _vm.a === i || _vm.b === i || _vm.c === i
      },
      style: ({
        backgroundImage: 'url(' + card.image + ')'
      }),
      on: {
        "click": function($event) {
          _vm.activate(i)
        }
      }
    }), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.a === i || _vm.b === i || _vm.c === i),
        expression: "a === i || b === i || c === i"
      }],
      staticClass: "custom-meet-team__info",
      class: {
        'custom-meet-team__info--active': _vm.a === i || _vm.b === i || _vm.c === i
      }
    }, [_c('div', {
      staticClass: "custom-meet-team__name",
      domProps: {
        "innerHTML": _vm._s(card.name)
      }
    }), _c('div', {
      staticClass: "custom-meet-team__position",
      domProps: {
        "innerHTML": _vm._s(card.position)
      }
    }), _c('div', {
      staticClass: "cusotm-meet-team__bio",
      domProps: {
        "innerHTML": _vm._s(card.bio)
      }
    })])])])
  })), _c('div', {
    staticClass: "custom-meet-team__team clearfix",
    class: {
      show: _vm.activeTab == 'team2', hide: _vm.activeTab != 'team2'
    }
  }, _vm._l((_vm.props.cards_springfield), function(card2, i) {
    return _c('div', {
      staticClass: "custom-meet-team__card",
      class: {
        'custom-meet-team__card--active': _vm.a === i || _vm.b === i || _vm.c === i
      }
    }, [_c('div', {
      staticClass: "custom-meet-team__white",
      class: {
        'custom-meet-team__white--active': _vm.a === i || _vm.b === i || _vm.c === i
      }
    }, [_c('div', {
      staticClass: "custom-meet-team__image",
      class: {
        'custom-meet-team__image--active': _vm.a === i || _vm.b === i || _vm.c === i
      },
      style: ({
        backgroundImage: 'url(' + card2.image + ')'
      }),
      on: {
        "click": function($event) {
          _vm.activate(i)
        }
      }
    }), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.a === i || _vm.b === i || _vm.c === i),
        expression: "a === i || b === i || c === i"
      }],
      staticClass: "custom-meet-team__info",
      class: {
        'custom-meet-team__info--active': _vm.a === i || _vm.b === i || _vm.c === i
      }
    }, [_c('div', {
      staticClass: "custom-meet-team__name",
      domProps: {
        "innerHTML": _vm._s(card2.name)
      }
    }), _c('div', {
      staticClass: "custom-meet-team__position",
      domProps: {
        "innerHTML": _vm._s(card2.position)
      }
    }), _c('div', {
      staticClass: "cusotm-meet-team__bio",
      domProps: {
        "innerHTML": _vm._s(card2.bio)
      }
    })])])])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8be060f4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-meet-team/custom-meet-team.pug
// module id = 544
// module chunks = 1